import { useAppBridge } from "@shopify/app-bridge-react";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function useSafeNavigate() {
  const navigate = useNavigate();
  const shopify = useAppBridge();

  return useCallback(
    async (to: string) => {
      console.log("kc: useSafeNavigate", to);
      try {
        // Check if savebar exists and is showing
        const settingsSaveBar = document.getElementById("settings-save-bar");
        const discountLinkSaveBar = document.getElementById("discount-link-save-bar");

        if (
          (settingsSaveBar as HTMLElement & { showing?: boolean }).showing ||
          (discountLinkSaveBar as HTMLElement & { showing?: boolean }).showing
        ) {
          await shopify.saveBar.leaveConfirmation();
          return; // Prevent navigation
        }
      } catch (unknown) {
        console.error("kc: useSafeNavigate", unknown);
      }
      // Navigate if no savebar is showing or there was an error
      navigate(to);
    },
    [navigate, shopify],
  );
}
